<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div class="payment-container p-3">
    <b-form id="frm" name="frm" @submit="onSubmit" @reset="onReset" ref="frm">
      <b-row class="justify-content-center">
        <b-col cols="12" lg="10">
          <b-card no-body class="shadow-sm border-0 mb-4">
            <!-- Header -->
            <div class="p-3 bg-primary text-white rounded-top d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-icon icon="pencil-square" class="mr-2"></b-icon>
                <h5 class="mb-0 h6">ແກ້ໄຂເອກະສານການຈ່າຍເງິນ</h5>
              </div>
              <b-button variant="light" size="sm" @click="goback">
                <b-icon icon="arrow-left" class="mr-1"></b-icon> ກັບຄືນ
              </b-button>
            </div>

            <div class="p-4">
              <!-- Section 1: ຂໍ້ມູນທົ່ວໄປ -->
              <div class="section-title mb-3">
                <h6 class="text-primary font-weight-bold"><b-icon icon="info-circle" class="mr-1"></b-icon> ຂໍ້ມູນທົ່ວໄປ</h6>
                <hr class="mt-1">
              </div>

              <b-row>
                <b-col md="6">
                  <b-form-group label="ສົກຮຽນ:" label-class="font-weight-bold">
                    <b-input-group>
                      <b-input-group-prepend is-text><b-icon icon="calendar3"></b-icon></b-input-group-prepend>
                      <b-form-input v-model="frm.accd" v-mask="'####-####'" placeholder="____-____" trim></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="ວັນທີ ເຂົ້າຂໍ້ມູນ:" label-class="font-weight-bold">
                    <b-form-datepicker required v-model="frm.crate_date" locale="lao"></b-form-datepicker>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="ລະຫັດໂຮງຮຽນ:" label-class="font-weight-bold" :description="schoolname ? 'ໂຮງຮຽນ: ' + schoolname : ''">
                    <b-input-group>
                      <b-input-group-prepend is-text><b-icon icon="house-door"></b-icon></b-input-group-prepend>
                      <b-form-input v-model="frm.school_id" @input="getschoolname" required trim></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Section 2: ເພີ່ມລາຍການໃໝ່ -->
              <div class="section-title mt-4 mb-3">
                <h6 class="text-primary font-weight-bold"><b-icon icon="plus-circle" class="mr-1"></b-icon> ເພີ່ມລາຍການຈ່າຍ</h6>
                <hr class="mt-1">
              </div>

              <div class="bg-light p-3 rounded border mb-4 shadow-sm">
                <b-row>
                  <b-col md="8">
                    <b-form-group label="ລາຍການ:" label-class="small font-weight-bold">
                      <b-form-select v-model="item.item_code" @change="getItem" :options="items"></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="ວັນທີ:" label-class="small font-weight-bold">
                      <b-form-datepicker v-model="item.trans_date" locale="lao" size="sm"></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="ຈຳນວນ:" label-class="small font-weight-bold">
                      <vue-numeric class="form-control text-right" separator="," v-model="item.value"></vue-numeric>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="ຫົວໜ່ວຍ:" label-class="small font-weight-bold">
                      <b-form-select v-model="item.unit" :options="units"></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="ຈຳນວນເງິນ:" label-class="small font-weight-bold">
                      <vue-numeric class="form-control text-right font-weight-bold text-primary" separator="," v-model="item.amount"></vue-numeric>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="ແຫຼ່ງທຶນ:" label-class="small font-weight-bold">
                      <b-form-select v-model="item.source_type" :options="source_types"></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div class="text-right">
                  <b-button variant="primary" size="sm" class="px-4" @click="onAdditem">
                    <b-icon icon="plus" class="mr-1"></b-icon> ເພີ່ມລົງຕາຕະລາງ
                  </b-button>
                </div>
              </div>

              <!-- Section 3: ຕາຕະລາງລາຍການ -->
              <div class="table-responsive">
                <b-table head-variant="light" hover striped :fields="fields" :items="frm.items" class="border rounded custom-table" foot-clone>
                  <template #cell(action)="data">
                    <b-button variant="outline-danger" size="sm" @click="onRemoveItem(data.index)">
                      <b-icon icon="trash"></b-icon>
                    </b-button>
                  </template>

                  <template #foot(description)>
                    <div class="text-right font-weight-bold">ລວມທັງໝົດ:</div>
                  </template>
                  <template #foot(amount)>
                    <div class="text-right font-weight-bold text-primary">{{ Total }}</div>
                  </template>
                  <template #foot(trans_date)><span></span></template>
                  <template #foot(value)><span></span></template>
                  <template #foot(unit)><span></span></template>
                </b-table>
              </div>

              <!-- Form Actions -->
              <div class="d-flex justify-content-end mt-4 pt-3 border-top">
                <b-button type="reset" variant="outline-danger" class="mr-2 px-4">
                  <b-icon icon="arrow-counterclockwise"></b-icon> ລ້າງຂໍ້ມູນ
                </b-button>
                <b-button type="submit" variant="success" class="px-5 font-weight-bold shadow-sm">
                  <b-icon icon="check2-circle"></b-icon> ບັນທຶກການແກ້ໄຂ
                </b-button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        this.frm.update_by = this.user.username

        axios
            .get(this.$store.getters.getBaseUrl + "/getItems/source_types/source_type_desc/source_type", {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.source_types = response.data;
            })

        axios
            .get(this.$store.getters.getBaseUrl + "/getItems/items/item_desc_lao/item_code", {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.items = response.data;
            })

            axios
            .get(this.$store.getters.getBaseUrl + "/getItems/units/unite_desc/unite_desc", {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.units = response.data;
            })

            axios
            .get(this.$store.getters.getBaseUrl + "/getDocitem/payment_trans/_id/"+  this.$route.params.val, {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.frm = response.data[0];
            })
    },
    data() {
        return {
            user: [],
            source_types: [],
            items: [],
            fields: [
                { label: 'ລາຍການ', key: 'description', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ວັນທີ', key: 'trans_date', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ຈຳນວນ', key: 'value', thClass: "col-md-2  text-right", tdClass: "col-md-2 text-right", formatter: "format" },
                { label: 'ຫົວໜ່ວຍ', key: 'unit', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ຈຳນວນເງີນ', key: 'amount', thClass: "col-md-2  text-right", tdClass: "col-md-2 text-right", formatter: "format" },
                // { label: 'ແຫຼ່ງທືນ', key: 'source_type', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: '...', key: 'action', thClass: "  text-right", tdClass: " text-right" },
            ],
            item: {
                "trans_date": "",
                "item_code": "",
                "description": "",
                "amount": 0,
                "value":0,
                "unit":"",
                "source_type": "GOV",
            },
            frm: {
                "item_code": "",
                "crate_date": "",
                "create_by": "",
                "trans_date": "",
                "total": 0,
                "status": "N",
                "del_by": "",
                "del_date": "",
                "update_by": "",
                "update_date": "",
                "ref_no": "",
                "description": "",
                "school_id": "",
                "source_type": "GOV",
                "accd": "",
                "items": [],
                "value":0,
                "unit":""
            },
            schoolname: "",
            units:""
        }
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },
        getschoolname() {

            axios
                .get(this.$store.getters.getBaseUrl + "/getRows/schools/school_id/" + this.frm.school_id, {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                })
                .then((response) => {
                    // JSON responses are automatically parsed.
                    try {
                        this.schoolname = response.data[0].school_name_lao;
                    } catch (error) {
                        this.schoolname = ""
                    }

                    // let rp= response.data;

                    //  console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        getItem() {
            axios
                .get(this.$store.getters.getBaseUrl + "/getRows/items/item_code/" + this.item.item_code, {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                })
                .then((response) => {
                    // JSON responses are automatically parsed.
                    try {
                        this.item.description = response.data[0].item_desc_lao;
                    } catch (error) {
                        this.item.description = ""
                    }

                    // let rp= response.data;

                    //  console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        onSubmit(event) {
            event.preventDefault();

            this.frm.update_by=this.user.username
            let d=new Date().toJSON()
            this.frm.update_date=d

            let rp_data = null;
            let sum = this.frm.items.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.amount);
            }, 0);
                this.frm.total=sum
             
            let postsdata = {
                table: "payment_trans",
                rows: this.frm,
                pkey: "_id",
                wharevalue: this.$route.params.val

            };
            axios
                .post(
                    this.$store.getters.getBaseUrl + "/jsonUpdate",
                    postsdata, {
                        headers: {
                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                )
                .then((rep) => {
                    rp_data = rep.data;
                    if (rp_data.msg == "Done") {
                        // alert(rp_data.desc);

                        this.$bvModal
                            .msgBoxOk(rp_data.desc, {
                                title: "ຂໍ້ວາມາແຈ້ງ.....",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,

                            }).then((value) => {
                                console.log(value)
                                this.$router.go(-1);
                            })

                    } else {
                        //alert(rp_data.desc);
                        this.$bvModal
                            .msgBoxOk(rp_data.desc, {
                                title: "Confirmation",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                    }
                });

        },
        onAdditem() {
            let row = {
                "trans_date": this.item.trans_date,
                "item_code": this.item.item_code,
                "description": this.item.description,
                "amount": this.item.amount,
                "source_type": this.item.source_type,
                "value": this.item.value,
                "unit": this.item.unit,
            }
            this.frm.items.push(row)
            this.item = {
                "trans_date": "",
                "item_code": "",
                "description": "",
                "amount": 0,
                "value":0,
                "unit":"",
                "source_type": "GOV",
            }
        },
        onRemoveItem(index) {
            this.frm.items.splice(index, 1)
        },
        total() {

            let sum = this.frm.items.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.amount);
            }, 0);

            return this.format(sum);

        },
        onReset(event) {
        event.preventDefault()

            this.frm.items=[]

        }

    },

    computed: {
        Total() {

            let sum = this.frm.items.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.amount);
            }, 0);

            return this.format(sum);

        },
    },
    filters: {
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },
    }

}
</script>

<style scoped>
.payment-container {
    background-color: #f0f2f5;
    min-height: 100vh;
}
.section-title hr {
    border-top: 2px solid #e9ecef;
}
.custom-table {
    background: white;
}
.custom-table ::v-deep th {
    background-color: #f8f9fa !important;
    color: #495057;
    font-weight: bold;
    text-align: center;
}
.form-control:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
    border-color: #80bdff;
}
.card {
    border-radius: 12px;
    overflow: hidden;
}
</style>